/*
 * @Description: 点击图片放大
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-05-07 10:22:09
 * @LastEditTime: 2020-10-10 18:09:01
 */
import Vue from "vue";
import Clipboard from "clipboard";

/**
 * 点击看大图
 * @param {*} ev
 */
function imgListener(ev) {
  Vue.prototype
    .$alert(
      `<img style="width: auto;max-height:600px;margin-top:10px;" src=${ev.target.src} />`,
      " ",
      {
        customClass: "img-look-box",
        dangerouslyUseHTMLString: true,
        closeOnPressEscape: true,
        showConfirmButton: false,
        showCancelButton: false,
        closeOnClickModal: true,
        showClose: true,
      }
    )
    .catch((e) => {
      console.log(e);
    });
}
export const amplifyImg = {
  bind(el, binding) {
    if (binding.value) {
      el.addEventListener("click", imgListener, false);
    }
  },
  unbind(el, binding) {
    if (binding.value) {
      el.removeEventListener("click", imgListener, false);
    }
  },
};

/**
 * 点击复制文本
 * @param {*} ev
 */
function copyListener(ev) {
  const clipboard = new Clipboard(ev);
  ev.setAttribute("data-clipboard-text", ev.getAttribute("data-url"));
  clipboard.on("success", (e) => {
    Vue.prototype.$toast({
      message: "复制成功",
      type: "success",
    });
    clipboard.destroy();
  });
  clipboard.on("error", (e) => {
    Vue.prototype.$toast({
      message: "复制失败",
      type: "warning",
    });
    clipboard.destroy();
  });
}
export const copy = {
  bind(el, binding) {
    copyListener.bind(this, el)();
    el.addEventListener("click", copyListener.bind(this, el), false);
  },
  unbind(el, binding) {
    el.removeEventListener("click", copyListener.bind(this, el), false);
  },
};
